import { getText } from '../../../../internal/TextLabels'
/* eslint-disable no-restricted-globals */
import { Countries } from '../../../../models/countries'
import { actOnData, getDeep } from '../../../../util/helpers'

export const PredefinedFormFields = {
  AMOUNT: 'amount',
  CARD_NUMBER: 'card-number',
  APPROVE_CONDITIONS: 'approve-conditions',
  ESKAT_CONSENT: 'eskat-consent',
  APPLICANT_ESKAT_CONSENT: 'applicant-eskat-consent',
  APPLICANT_CONSENT_EMAIL_MARKETING: 'applicant-consent-email-marketing',
  APPLICANT_CONSENT_SMS_MARKETING: 'applicant-consent-sms-marketing',
  CO_APPLICANT_ID: 'coapplicant-government-id',
  CO_APPLICANT_PHONE: 'coapplicant-mobile-number',
  CO_APPLICANT_EMAIL: 'coapplicant-email-address',
  CO_APPLICANT_CHECK: 'co-applicant-check',
  INCREASE_EXISTING_CERDIT: 'increase-existing-credit',
  APPLICANT_GOVERNMENT_ID: 'applicant-government-id',
  APPLICANT_CITIZENSHIP: 'applicant-citizenship',
  APPLICANT_ANCESTRAL_HOMELAND: 'applicant-ancestral-homeland',
  APPLICANT_IN_DENMARK_SINCE_YEAR: 'applicant-in-denmark-since-year',
  APPLICANT_RESIDENT_PERMIT: 'applicant-resident-permit',
  APPLICANT_RESIDENT_PERMIT_VALID_DATE: 'applicant-resident-permit-valid-date',
  APPLICANT_MOBILE_NUMBER: 'applicant-mobile-number',
  APPLICANT_TELEPHONE_NUMBER: 'applicant-telephone-number',
  APPLICANT_EMAIL_ADDRESS: 'applicant-email-address',
  APPLICANT_PERMISSION: 'applicant-permission',
  APPLICANT_MARITAL_STATUS: 'applicant-marital-status',
  APPLICANT_ACCOMODATION_TYPE: 'applicant-accomodation-type',
  APPLICANT_CHILDRENS: 'applicant-childrens',
  APPLICANT_EMPLOYMENT_TYPE: 'applicant-employment-type',
  APPLICANT_EMPLOYMENT_YEAR: 'applicant-employment-year',
  APPLICANT_EMPLOYMENT_YEAR_FROM: 'applicant-employment-year-from',
  APPLICANT_EMPLOYER: 'applicant-employer',
  APPLICANT_WORK_TELEPHONE_NUMBER: 'applicant-work-telephone-number',
  APPLICANT_MONTHLY_INCOME: 'applicant-monthly-income',
  APPLICANT_MONTHLY_INCOME_BEFORE_TAXES:
    'applicant-monthly-income-before-taxes',
  APPLICANT_MONTHLY_INCOME_AFTER_TAXES: 'applicant-monthly-income-after-taxes',
  APPLICANT_MEMBER_OF_A_KASSE: 'applicant-member-of-a-kasse',
  APPLICANT_WITH_BANK_SINCE_YEAR: 'applicant-with-bank-since-year',
  APPLICANT_DANKORT: 'applicant-dankort',
  APPLICANT_ADVERTISEMENT: 'applicant-advertisement',
  APPLICANT_EDUCATIONAL_LEVEL: 'applicant-educational-level',
  APPLICANT_HABITATION_YEAR: 'applicant-habitation-year',
  HOUSEHOLD_LIVING_EXPENSES: 'household-living-expenses',
  HOUSEHOLD_MONTHLY_AMOUNT_AFTER_EXPENSES:
    'household-monthly-amount-after-expenses',
  MONTHLY_AMOUNT_AFTER_EXPENSES: 'monthly-amount-after-expenses',
  APPLICANT_MONTHLY_AMOUNT_AFTER_EXPENSES:
    'applicant-monthly-amount-after-expenses',
  CO_APPLICANT_EMPLOYMENT_TYPE: 'coapplicant-employment-type',
  CO_APPLICANT_EMPLOYMENT_YEAR: 'coapplicant-employment-year',
  CO_APPLICANT_EMPLOYER: 'coapplicant-employer',
  CO_APPLICANT_WORK_TELEPHONE_NUMBER: 'coapplicant-work-telephone-number',
  CO_APPLICANT_MONTHLY_INCOME_BEFORE_TAXES:
    'coapplicant-monthly-income-before-taxes',
  CO_APPLICANT_MONTHLY_INCOME_AFTER_TAXES:
    'coapplicant-monthly-income-after-taxes',
  CO_APPLICANT_CONSENT_EMAIL_MARKETING: 'coapplicant-consent-email-marketing',
  CO_APPLICANT_CONSENT_SMS_MARKETING: 'coapplicant-consent-sms-marketing',
  CO_APPLICANT_CREDIT_STATUS_CONSENT: 'coapplicant-credit-status-consent',
  APPLICANT_PEP: 'applicant-pep',
  APPLICANT_PEP_POSITION: 'applicant-pep-position',
  APPLICANT_PEP_COUNTRY: 'applicant-pep-country',
  APPLICANT_PEP_NAME: 'applicant-pep-name',
  CO_APPLICANT_PEP: 'coapplicant-pep',
  CO_APPLICANT_PEP_POSITION: 'coapplicant-pep-position',
  CO_APPLICANT_PEP_COUNTRY: 'coapplicant-pep-country',
  CO_APPLICANT_PEP_NAME: 'coapplicant-pep-name',
  APPLICANT_PERMANENT_EMPLOYMENT: 'applicant-permanent-employment',
  CO_APPLICANT_PERMANENT_EMPLOYMENT: 'coapplicant-permanent-employment',
  APPLICANT_ADDRESS_STREET: 'applicant-address-street',
  APPLICANT_ADDRESS_POSTAL_CODE: 'applicant-address-postalcode',
  APPLICANT_ADDRESS_AREA: 'applicant-address-area',
  APPLICANT_ADDRESS_COUNTRY: 'applicant-address-country',
  CONFIRM_REGISTER_CONSENT: 'confirm-register-consent',
  ALL_LOAN_EXPENSES: 'all-loan-expenses',
}

const PEPTypes = {
  NO: 'no',
  PEP: 'pep',
  PEP_FAMILY: 'pepf',
  PEP_COWORKER: 'pepm',
  PEP_BINGO: 'peppepass',
}

const EmploymentTypes = {
  WHITE_COLLAR_WORKER: 'WHITE_COLLAR_WORKER',
  PAID_BY_HOUR: 'PAID_BY_HOUR',
  MANAGER: 'MANAGER',
  TEAM_LEADER: 'TEAM_LEADER',
  FAST_ANSTALLD: 'FAST_ANSTALLD',
  ENTREPRENEUR: 'ENTREPRENEUR',
  EGEN_FORETAGARE: 'EGEN_FORETAGARE',
  VIKARIAT: 'VIKARIAT',
  PRE_PENSIONER: 'PRE_PENSIONER',
  PENSIONAR: 'PENSIONAR',
  STUDENT: 'STUDENT',
  TRAINEE: 'TRAINEE',
  ARBETSLOS: 'ARBETSLOS',
  STAYING_AT_HOME: 'STAYING_AT_HOME',
  OTHER: 'OTHER',
}

const Citizenship = {
  DANISH: 'DANISH',
  OTHER: 'OTHER',
}

const HelpTexts = {
  AMOUNT_AFTER_EXPENSES_DK:
    'Rådighedsbeløbet er det beløb af din løn, som er tilbage, når der er betalt skat, arbejdsmarkedsbidrag og faste udgifter. Faste udgifter udgør afdrag på gæld, husleje, transportomkostninger, el, vand, varme, licens, forsikringer og kontingenter mv. Altså omkostninger, som er faste beløb og beløb, som man har forpligtet sig til at betale jævnt over året.\nRådighedsbeløbet er altså det beløb, som kan bruge til mad, rengøring, tøj, kultur mv.',
}

const currencyFields = [
  PredefinedFormFields.APPLICANT_MONTHLY_INCOME,
  PredefinedFormFields.HOUSEHOLD_LIVING_EXPENSES,
  PredefinedFormFields.ALL_LOAN_EXPENSES,
  PredefinedFormFields.APPLICANT_MONTHLY_INCOME_BEFORE_TAXES,
  PredefinedFormFields.CO_APPLICANT_MONTHLY_INCOME_BEFORE_TAXES,
  PredefinedFormFields.APPLICANT_MONTHLY_INCOME_AFTER_TAXES,
  PredefinedFormFields.CO_APPLICANT_MONTHLY_INCOME_AFTER_TAXES,
]

export const PredefinedHeadings = {
  SUBTITLE_COAPPLICANT: 'subtitle-coApplicant',
  COAPPLICANT_BLOCK: 'coapplicant-block',
}

export const PredefinedGroups = {
  CREDIT_CARDS_GROUP: 'credit-cards-group',
  APPLICANT_NUMBER_OF_CHILDREN_IN_AGE_GROUP:
    'applicant-number-of-children-in-age-group',
}

export const FutureDateField = {
  [PredefinedFormFields.APPLICANT_RESIDENT_PERMIT_VALID_DATE]: !0,
}

export const PastDateField = {
  [PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR]: !0,
  [PredefinedFormFields.APPLICANT_IN_DENMARK_SINCE_YEAR]: !0,
  [PredefinedFormFields.APPLICANT_WITH_BANK_SINCE_YEAR]: !0,
  [PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_YEAR]: !0,
  [PredefinedFormFields.APPLICANT_HABITATION_YEAR]: !0,
}

const isPEP = pepAnswer => {
  switch (pepAnswer) {
    case PEPTypes.PEP:
    case PEPTypes.PEP_FAMILY:
    case PEPTypes.PEP_COWORKER:
    case PEPTypes.PEP_BINGO:
      return true
    case PEPTypes.NO:
    default:
      return false
  }
}

const isPEPNameRequired = pepAnswer => {
  switch (pepAnswer) {
    case PEPTypes.PEP_FAMILY:
    case PEPTypes.PEP_COWORKER:
    case PEPTypes.PEP_BINGO:
      return true
    case PEPTypes.PEP:
    case PEPTypes.NO:
    default:
      return false
  }
}

const hasActiveEmployment = employmentType => {
  switch (employmentType) {
    case EmploymentTypes.PRE_PENSIONER:
    case EmploymentTypes.PENSIONAR:
    case EmploymentTypes.STUDENT:
    case EmploymentTypes.TRAINEE:
    case EmploymentTypes.ARBETSLOS:
    case EmploymentTypes.STAYING_AT_HOME:
      return false
    default:
      return true
  }
}

const isStudent = employmentType => {
  switch (employmentType) {
    case EmploymentTypes.STUDENT:
    case EmploymentTypes.TRAINEE:
      return true
    default:
      return false
  }
}

const fieldConstraint = (fieldName, constraint, defaultValue) =>
  function (appData) {
    // eslint-disable-next-line react/destructuring-assignment
    const result = actOnData(appData[fieldName], value => constraint(value))
    return result !== null ? result : defaultValue
  }

const isCoApplicantChecked = appData =>
  fieldConstraint(
    PredefinedFormFields.CO_APPLICANT_CHECK,
    checked => !!checked,
  )(appData)

const isFaroeIslands = appData =>
  fieldConstraint(
    PredefinedFormFields.APPLICANT_ADDRESS_COUNTRY,
    country => country === 'FO',
  )(appData)

const Mandatory = Object.freeze({
  hidden: false,
  skipped: false,
  mandatory: true,
})

const Skipped = Object.freeze({
  hidden: true,
  skipped: true,
  mandatory: false,
})

const dynamicSpecGeneral = {
  [PredefinedFormFields.APPLICANT_GOVERNMENT_ID]: () => ({
    hidden: true,
  }),
  [PredefinedFormFields.APPLICANT_TELEPHONE_NUMBER]: (appData, spec) => ({
    hidden: !!spec.value,
  }),
  [PredefinedFormFields.CO_APPLICANT_ID]: appData => ({
    completeCoApplicantButton: true,
    ...(isCoApplicantChecked(appData) ? Mandatory : Skipped),
  }),
  [PredefinedFormFields.APPLICANT_PERMISSION]: () => ({
    hidden: true,
  }),
  [PredefinedFormFields.APPLICANT_ADVERTISEMENT]: () => ({
    hidden: true,
  }),
  [PredefinedFormFields.CO_APPLICANT_CHECK]: () => ({
    skipped: true,
  }),
  [PredefinedFormFields.CO_APPLICANT_PHONE]: appData =>
    isCoApplicantChecked(appData) ? Mandatory : Skipped,
  [PredefinedFormFields.CO_APPLICANT_EMAIL]: appData =>
    isCoApplicantChecked(appData) ? Mandatory : Skipped,
  [PredefinedHeadings.SUBTITLE_COAPPLICANT]: appData =>
    isCoApplicantChecked(appData)
      ? { showHeading: true }
      : { showHeading: false },
  [PredefinedHeadings.COAPPLICANT_BLOCK]: appData =>
    isCoApplicantChecked(appData)
      ? { showHeading: true }
      : { showHeading: false },
  [PredefinedFormFields.APPLICANT_CONSENT_EMAIL_MARKETING]: () => Skipped,
  [PredefinedFormFields.APPLICANT_CONSENT_SMS_MARKETING]: () => Skipped,
  [PredefinedFormFields.CO_APPLICANT_CONSENT_EMAIL_MARKETING]: () => Skipped,
  [PredefinedFormFields.CO_APPLICANT_CONSENT_SMS_MARKETING]: () => Skipped,
  [PredefinedFormFields.APPROVE_CONDITIONS]: () => ({
    value: true,
    hidden: true,
  }),
  [PredefinedFormFields.APPLICANT_PEP_COUNTRY]: appData =>
    fieldConstraint(PredefinedFormFields.APPLICANT_PEP, isPEP)(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_PEP_POSITION]: appData =>
    fieldConstraint(PredefinedFormFields.APPLICANT_PEP, isPEP)(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_PEP_NAME]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_PEP,
      isPEPNameRequired,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_PEP_COUNTRY]: appData =>
    fieldConstraint(PredefinedFormFields.CO_APPLICANT_PEP, isPEP)(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_PEP_POSITION]: appData =>
    fieldConstraint(PredefinedFormFields.CO_APPLICANT_PEP, isPEP)(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_PEP_NAME]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_PEP,
      isPEPNameRequired,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_PERMANENT_EMPLOYMENT,
      value => value === 'true',
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_YEAR]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_PERMANENT_EMPLOYMENT,
      value => value === 'true',
    )(appData)
      ? Mandatory
      : Skipped,
}

const isDanishCitizen = appData =>
  fieldConstraint(
    PredefinedFormFields.APPLICANT_CITIZENSHIP,
    citizenship => citizenship === Citizenship.DANISH,
  )(appData)

const isPermanentResidentPermit = appData =>
  fieldConstraint(
    PredefinedFormFields.APPLICANT_RESIDENT_PERMIT,
    residentPermit => ['B', 'D', 'H', 'L'].includes(residentPermit),
  )(appData)

const dynamicSpecDk = {
  [PredefinedFormFields.APPLICANT_TELEPHONE_NUMBER]: () => ({
    hidden: false,
  }),
  [PredefinedFormFields.APPLICANT_IN_DENMARK_SINCE_YEAR]: appData =>
    isDanishCitizen(appData) ? Skipped : Mandatory,
  [PredefinedFormFields.APPLICANT_RESIDENT_PERMIT]: appData =>
    isDanishCitizen(appData) ? Skipped : Mandatory,
  [PredefinedFormFields.APPLICANT_RESIDENT_PERMIT_VALID_DATE]: appData =>
    isDanishCitizen(appData) || isPermanentResidentPermit(appData)
      ? Skipped
      : Mandatory,
  [PredefinedFormFields.APPLICANT_MONTHLY_INCOME_AFTER_TAXES]: (
    appData,
    spec,
  ) => ({
    max: fieldConstraint(
      PredefinedFormFields.APPLICANT_MONTHLY_INCOME_BEFORE_TAXES,
      beforeTaxes => Math.min(spec.max, Math.max(beforeTaxes - 1, 0)),
      spec.max,
    )(appData),
  }),
  [PredefinedFormFields.HOUSEHOLD_MONTHLY_AMOUNT_AFTER_EXPENSES]: (
    appData,
    spec,
  ) => ({
    max: fieldConstraint(
      PredefinedFormFields.APPLICANT_MONTHLY_INCOME_AFTER_TAXES,
      afterTaxes => Math.min(spec.max, Math.max(afterTaxes - 1, 0)),
      spec.max,
    )(appData),
    helpText: HelpTexts.AMOUNT_AFTER_EXPENSES_DK,
  }),
  [PredefinedFormFields.MONTHLY_AMOUNT_AFTER_EXPENSES]: (appData, spec) => ({
    max: fieldConstraint(
      PredefinedFormFields.APPLICANT_MONTHLY_INCOME_AFTER_TAXES,
      afterTaxes => Math.min(spec.max, Math.max(afterTaxes - 1, 0)),
      spec.max,
    )(appData),
    helpText: HelpTexts.AMOUNT_AFTER_EXPENSES_DK,
  }),
  [PredefinedFormFields.APPLICANT_MONTHLY_AMOUNT_AFTER_EXPENSES]: (
    appData,
    spec,
  ) => ({
    max: fieldConstraint(
      PredefinedFormFields.APPLICANT_MONTHLY_INCOME_AFTER_TAXES,
      afterTaxes => Math.min(spec.max, Math.max(afterTaxes - 1, 0)),
      spec.max,
    )(appData),
    helpText: HelpTexts.AMOUNT_AFTER_EXPENSES_DK,
  }),
  [PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_EMPLOYER]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_WORK_TELEPHONE_NUMBER]: (appData, spec) =>
    (spec && spec.mandatory) ||
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_EDUCATIONAL_LEVEL]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      isStudent,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_MONTHLY_INCOME_AFTER_TAXES]: (
    appData,
    spec,
  ) => ({
    max: fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_MONTHLY_INCOME_BEFORE_TAXES,
      beforeTaxes => Math.min(spec.max, Math.max(beforeTaxes - 1, 0)),
      spec.max,
    )(appData),
  }),
  [PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_YEAR]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_EMPLOYER]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_EMPLOYER]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.CO_APPLICANT_WORK_TELEPHONE_NUMBER]: appData =>
    fieldConstraint(
      PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.ESKAT_CONSENT]: () => ({
    type: 'hidden',
    value: true,
  }),
  [PredefinedFormFields.APPLICANT_ESKAT_CONSENT]: () => ({
    type: 'hidden',
    value: true,
  }),
  [PredefinedFormFields.CO_APPLICANT_CREDIT_STATUS_CONSENT]: () => ({
    type: 'hidden',
  }),
  [PredefinedGroups.CREDIT_CARDS_GROUP]: () => ({
    type: 'group-label',
  }),
  [PredefinedFormFields.APPLICANT_ADDRESS_AREA]: appData =>
    isFaroeIslands(appData)
      ? {
          readOnly: true,
        }
      : {},
  [PredefinedFormFields.APPLICANT_ADDRESS_COUNTRY]: appData =>
    isFaroeIslands(appData)
      ? {
          readOnly: true,
        }
      : {},
  [PredefinedGroups.APPLICANT_NUMBER_OF_CHILDREN_IN_AGE_GROUP]: () => ({
    type: 'group-label',
  }),
}

const dynamicSpecFi = {
  [PredefinedFormFields.APPLICANT_EMPLOYER]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR_FROM]: appData =>
    fieldConstraint(
      PredefinedFormFields.APPLICANT_EMPLOYMENT_TYPE,
      hasActiveEmployment,
    )(appData)
      ? Mandatory
      : Skipped,
  [PredefinedFormFields.HOUSEHOLD_LIVING_EXPENSES]: (appData, spec) => ({
    inputHelpText: spec.description,
  }),
  [PredefinedFormFields.ALL_LOAN_EXPENSES]: (appData, spec) => ({
    inputHelpText: spec.description,
  }),
  [PredefinedFormFields.APPLICANT_MOBILE_NUMBER]: (appData, spec) => ({
    formatMessage:
      appData[PredefinedFormFields.APPLICANT_MOBILE_NUMBER]?.length > 15
        ? `${spec.formatMessage} Numero voi olla enintään 15 merkkiä`
        : spec.formatMessage,
  }),
}

const dynamicSpec = countryCode => {
  switch (countryCode) {
    case Countries.FI:
      return dynamicSpecFi
    case Countries.DK:
      return dynamicSpecDk
    default:
      return {}
  }
}

const _dkOverrides = entry => {
  switch (entry.name) {
    case PredefinedFormFields.APPLICANT_RESIDENT_PERMIT_VALID_DATE:
    case PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR:
    case PredefinedFormFields.APPLICANT_IN_DENMARK_SINCE_YEAR:
    case PredefinedFormFields.APPLICANT_WITH_BANK_SINCE_YEAR:
    case PredefinedFormFields.CO_APPLICANT_EMPLOYMENT_YEAR:
    case PredefinedFormFields.APPLICANT_HABITATION_YEAR:
      return {
        unit:
          entry.maxLength === 6
            ? getText('payApply.paymentMethodForm.monthYearPlaceholderLong')
            : getText('payApply.paymentMethodForm.monthYearPlaceholder'),
      }
    case (/applicant-number-of-children-in-age.*/.exec(entry.name) || [])[0]:
      return {
        type: 'step-integer',
        value: '0',
      }
    default:
      return {}
  }
}

/*
Workaround since the field is set as hidden but mandatory
 */
const _fiOverrides = entry => {
  switch (entry.name) {
    case PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR:
    case PredefinedFormFields.APPLICANT_EMPLOYMENT_YEAR_FROM:
      return {
        hidden: false,
        type: 'text',
      }
    case PredefinedFormFields.CONFIRM_REGISTER_CONSENT:
      return {
        label: entry.label || getDeep(entry, 'options.0.label'),
      }
    default:
      return {}
  }
}

const _overrides = countryCode => {
  switch (countryCode) {
    case Countries.FI:
      return _fiOverrides
    case Countries.DK:
      return _dkOverrides
    default:
      return () => ({})
  }
}

const integerToCurrencyOverrides = entry => {
  if (entry.type === 'integer' && currencyFields.includes(entry.name)) {
    return {
      type: 'currency',
    }
  }
  return {}
}

export const createDynamicSpecMap = (countryCode, formData) => {
  return formData
    .filter(entry => entry.name)
    .reduce(
      (ruleMap, entry) => ({
        ...ruleMap,
        [entry.name]: appData => ({
          ...entry,
          ..._overrides(countryCode)(entry),
          ...integerToCurrencyOverrides(entry),
          ...(entry.name.includes('coapplicant') &&
          isCoApplicantChecked(appData)
            ? Mandatory
            : {}),
          ...(actOnData(dynamicSpecGeneral[entry.name], func =>
            func(appData, entry),
          ) || {}),
          ...(actOnData(dynamicSpec(countryCode)[entry.name], func =>
            func(appData, entry),
          ) || {}),
          ...(entry.name.includes('coapplicant') &&
          !isCoApplicantChecked(appData)
            ? Skipped
            : {}),
        }),
      }),
      {},
    )
}
